import { toast } from 'react-toastify';
import api from "~/services/api";

async function sendAttachment(id, base64Data, name, setFileAttached, setIsLoading) {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      name,
      data: base64Data,
      description: 'Comprovante de pagamento'
    };

    setIsLoading(true);

    try {
      const res =  await api.post(`/sales/order/v2/orders-ga/${id}/attachments`, body, parameters);

      if (res.status !== 200 && res.status !== 201) {
        toast.error("Ocorreu um erro interno na aplicação");
        setFileAttached(false);
      } else {
        toast.success("Anexo do comprovante concluído com sucesso");
        setFileAttached(true);
      }
    } catch (error) {
      setFileAttached(false);
      toast.error('Não foi possível anexar o comprovante. Por favor, tente novamente ou acione o SAP Local.');
    }

    setIsLoading(false);
}


export async function sendAttachmentValidate(id, setIsLoading) {

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem("access_token")
  };
  const parameters = {
    method: 'POST',
    headers: header,
  };

  setIsLoading(true)

  try {
    const res =  await api.post(`/sales/order/v2/orders-ga/${id}/attachments/validate`,{},parameters)
    if (res.status !== 204) {
      toast.error("Ocorreu um erro interno na aplicação");
    } 
  } catch (error) {
    toast.error('Não foi possível finalizar o envio dos comprovantes.  Por favor, tente novamente ou acione o SAP Local.');
 }
 setIsLoading(false)
}


const handleFileSelect = (id, event, setFileAttached, setIsLoading) => {
  const file = event.target.files[0];
  if (file) {
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

    if (!allowedTypes.includes(file.type)) {
      toast.error('Tipo de arquivo não suportado. Por favor, escolha uma imagem, PDF ou documento do Word.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const base64Data = e.target.result.split(',')[1]; 
      const bytes = atob(base64Data).split('').map(char => char.charCodeAt(0));
      const sizeInMB = bytes.length / (1024 * 1024);
      const maxFileSizeMB = 20;

      if (sizeInMB > maxFileSizeMB) {
        toast.error("A imagem excede o tamanho máximo permitido de 20 MB. Por favor, escolha uma imagem menor.");
        return;
      }

      sendAttachment(id, base64Data, file.name, setFileAttached, setIsLoading);
    };
    reader.readAsDataURL(file);
  }
}

const attachDocument = (id, setFileAttached, setIsLoading) => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*, .pdf, .doc, .docx"; 
  input.onchange = (event) => handleFileSelect(id, event, setFileAttached, setIsLoading);
  input.click();
}

export default attachDocument;

